import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import api from '../../services/api';

// Cargar un equipo en un cliente del Portal Empresa desde su ficha (14-oct-2026).
// Sin N/S (instalación nueva) el backend le genera uno (18-oct-2026).
const INPUT = 'w-full h-11 px-3.5 rounded-xl bg-card text-ink text-body outline-none placeholder:text-muted';

export default function AgregarEquipo({ sedeId, onCancelar, onListo }) {
    const [d, setD] = useState({ numeroSerie: '', modelo: '', ubicacion: '' });
    const [guardando, setGuardando] = useState(false);
    const set = k => e => setD(x => ({ ...x, [k]: e.target.value }));
    const guardar = async () => {
        setGuardando(true);
        try {
            // Sin N/S (instalación nueva) el sistema le genera uno (18-oct-2026)
            const r = await api.post(`/empresa/clientes/${sedeId}/equipos`, d);
            toast.success(r.data.serieGenerada ? `Equipo cargado con N/S ${r.data.serie} (generado)` : `Equipo ${r.data.serie} cargado`);
            onListo();
        } catch (e) { toast.error(e?.response?.data?.mensaje || 'No se pudo cargar'); setGuardando(false); }
    };
    return (
        <div className="p-3 rounded-xl bg-panel space-y-2">
            <input className={INPUT} placeholder="N/S del equipo" value={d.numeroSerie} onChange={set('numeroSerie')} autoFocus autoCapitalize="characters" />
            {!d.numeroSerie.trim() && <p className="px-1 text-label text-muted">Si todavía no tiene N/S (instalación nueva), dejalo vacío y se genera solo. Después lo podés cambiar por el de ustedes.</p>}
            <div className="grid grid-cols-2 gap-2">
                <input className={INPUT} placeholder="Modelo" value={d.modelo} onChange={set('modelo')} />
                <input className={INPUT} placeholder="Dónde está (ej. cocina)" value={d.ubicacion} onChange={set('ubicacion')} />
            </div>
            <div className="flex gap-2">
                <button type="button" onClick={onCancelar} className="flex-1 h-10 rounded-xl bg-chip text-label font-black text-secondary">Cancelar</button>
                <button type="button" onClick={guardar} disabled={guardando} className="flex-[2] h-10 rounded-xl bg-brand-red text-white text-label font-black disabled:opacity-50">{guardando ? 'Guardando…' : 'Guardar equipo'}</button>
            </div>
        </div>
    );
}
